"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PORTRAIT_VARIANT_MAP = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _portrait_ = _interopRequireDefault(require("../../../asset/portrait_1.png"));

var _portrait_2 = _interopRequireDefault(require("../../../asset/portrait_2.png"));

var _portrait_3 = _interopRequireDefault(require("../../../asset/portrait_3.png"));

var _portrait_4 = _interopRequireDefault(require("../../../asset/portrait_4.png"));

var _portrait_5 = _interopRequireDefault(require("../../../asset/portrait_5.png"));

var _portrait_6 = _interopRequireDefault(require("../../../asset/portrait_6.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const PORTRAIT_VARIANT_MAP = {
  1: _portrait_.default,
  2: _portrait_2.default,
  3: _portrait_3.default,
  4: _portrait_4.default,
  5: _portrait_5.default,
  6: _portrait_6.default
};
exports.PORTRAIT_VARIANT_MAP = PORTRAIT_VARIANT_MAP;

/**
 * The Portrait component renders a selected hand-drawn portrait from a set. It
 * returns an `<img>` HTML element with the "src" attribute set to a value
 * determined by the "variant" prop.
 *
 * By default, the "height" and "width" attribtues are set to designer-specifed
 * size values, although this can be overridden by passing your own props.
 *
 * The `Portrait` component will pass all unhandled props to the root image
 * element, thereby accepting all HTML img attributes.
 */
const Portrait = ({
  variant = 1,
  ...otherProps
}) => (0, _pragma.createFelaElement)("img", _extends({
  alt: "",
  height: "auto",
  loading: "lazy",
  src: PORTRAIT_VARIANT_MAP[variant],
  width: 320
}, otherProps));

Portrait.displayName = 'Portrait';
var _default = Portrait;
exports.default = _default;
//# sourceMappingURL=Portrait.js.map